<template>
  <div class="form2">
    <div class="page_form">
      <el-form label-width="200px" size="small">
        <el-form-item label="被邀人资格设置">
          <el-radio label="0" v-model="formData.inviteQuery">新客户</el-radio>
          <el-radio label="1" v-model="formData.inviteQuery">未消费客户</el-radio>
        </el-form-item>
        <el-form-item label="接受邀请奖励">
          <div class="send_line">
            <span style="margin-right: 15px">优惠券</span>
            <div class="padding10">
              <el-tag
                v-for="(tag, index) in sList"
                :key="tag.id"
                closable
                @close="delTagItem(index)"
                style="margin-bottom:5px;margin-right:5px;">
                {{ tag.name }}
                <span v-if="tag.choseNum != 1">
                  <span class="colorRed">×</span>{{ tag.choseNum }} 张
                </span>
              </el-tag>
            </div>
            <el-button @click="showSelecter = true">选择优惠券</el-button>
          </div>
          <div class="send_line">
            <span style="margin-right: 15px">积分</span>
            <el-input v-model="formData.point" class="small_input"></el-input>
          </div>
          <div class="send_line">
            <span style="margin-right: 15px">余额</span>
            <el-input v-model="formData.balance" class="small_input"></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-form label-width="200px">
      <el-form-item>
        <div style="margin-top: 30px">
          <el-button @click="lastStep()">上一步</el-button>
          <el-button type="primary" @click="nextStep()">下一步</el-button>
        </div>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false" width="840px">
      <newSelectCommodityNum
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { mapGetters } from "vuex"
export default {
  computed: {
    ...mapGetters(["token", "app_id", "inviteForm"])
  },
  components: {
    newSelectCommodityNum
  },
  data(){
    return{
      formData:{
        inviteQuery: "0",
        sendType: [],
        point: "",
        balance: "",
      },
      showSelecter: false,
      sList: [],
    }
  },
  methods:{
    nextStep(){
      console.log(this.formData)
      var c = [];
      this.sList.forEach( cItem => {
        console.log(cItem)
        var i = 0;
        do{
          c.push(cItem.id);
          i++;
        }while(i<cItem.choseNum)
      })
      var thisForm2 = {
        new_user: this.formData.inviteQuery == "0"? 1: 0,
        no_custom: this.formData.inviteQuery == "1"? 1: 0,
        register_reward: {
          point: this.formData.point,
          balance: this.formData.balance,
          coupon: c.join(',')
        }
      }
      console.log(thisForm2)
      var newData2 = Object.assign(thisForm2,this.inviteForm)
      console.log(newData2)
      // return false
      this.$store.commit("SET_INVITEFORM",newData2)
      this.$emit('nextStep')
    },
    lastStep(){
      this.$emit('lastStep')
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //删除选择的优惠券
    delTagItem(i) {
      console.log(i);
      this.sList.splice(i, 1);
    },
  }
}
</script>
<style lang="scss" scoped>
.page_form{
  margin-top: 20px;
}
.select_box1{
  width: 140px;
}
.select_box2{
  width: 90px;
}
.extra_line{
  margin-top: 20px;
  span{
    margin-right: 10px;
  }
}
.block_checkbox{
  display: block;
  margin-bottom: 10px;
}
.ques_button{
  font-size: 21px;
  margin-left: 10px;
  vertical-align: middle;
  padding: 0
}
.small_input{
  width: 70px;
  margin: 0 5px;
}
.padding10 {
  padding: 0 10px;
  display: inline-block;
}
.send_line{
  height: 38px;
  margin-bottom: 10px;
}
</style>